import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function GoogleAd() {
  const location = useLocation();
  const isDebug =
    process.env.REACT_APP_ENV === "DEBUG" ||
    process.env.REACT_APP_ENV === "LOCAL";

  const adClient = isDebug
    ? "ca-pub-3940256099942544" // 測試用 ID
    : "ca-pub-6834073885546755"; // 正式用 ID
  const adSlot = isDebug ? "6300978111" : "1722497358";

  useEffect(() => {
    if (isDebug || typeof window === "undefined") return;

    if (window.adsbygoogle && Array.isArray(window.adsbygoogle)) {
      try {
        window.adsbygoogle.push({});
      } catch (e) {
        console.error("Adsense load failed:", e);
      }
    }
  }, [location.pathname, isDebug]); // 👈 加上 isDebug

  if (isDebug) {
    return (
      <div
        style={{
          display: "block",
          backgroundColor: "#f0f0f0",
          color: "#999",
          textAlign: "center",
          padding: "1rem",
          borderRadius: "4px",
          fontSize: "0.9rem",
          width: "100%",
          height: "600px",
        }}
      >
        [廣告位置 - DEBUG 環境]
      </div>
    );
  }

  return (
    <ins
      key={location.pathname}
      className="adsbygoogle"
      style={{
        display: "block",
        width: "100%",
        height: "600px",
      }}
      data-ad-client={adClient}
      data-ad-slot={adSlot}
      data-ad-format="auto"
      data-full-width-responsive="true"
    ></ins>
  );
}
